import './page-not-found.scss';
import * as pageNotFoundController from './page-not-found.controller';
import gzGo from 'gazelle/src/components/go/go.module';

const pageNotFoundState = {
  name: 'not-found',
  url: '/not-found?reason&detail',
  template: require('./page-not-found.jade'),
  controller: 'PageNotFoundController',
  controllerAs: 'vm'
};

export default angular.module('gazelle.components.pageNotFound', [
  'ui.router',
  gzGo,
])
  .controller(pageNotFoundController.name, pageNotFoundController.default)
  .constant('gzPageNotFoundState', pageNotFoundState)
  .name;
